export default __webpack_public_path__ + "static/media/war1.50bac846.png";